module.exports = __webpack_public_path__ + "img/BE0400040965.5520fb02.png";